export default __webpack_public_path__ + "static/media/13.20ea00ab.webp";